import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { BaseEntity } from "yt-ng-framework";

export class ProveraPosiljaoca extends BaseEntity{
    constructor(){
        super();
    }
    NazivPosiljaoca: string = null;
    PibPosiljaoca: string = null;
    MaticniBrojPosiljaoca: string = null;
    UlicaPosiljaoca: string = null;
    GradPosiljaoca: string = null;
    PostojiUBazi: string = null;
    Postoji: Boolean = null;
    BrojDokumenta: string = null;
    DatumDokumenta: Date = null;

    Deserialize(input: any){
        this.NazivPosiljaoca = input.NazivPosiljaoca;
        this.PibPosiljaoca = input.PibPosiljaoca;
        this.MaticniBrojPosiljaoca = input.MaticniPosiljaoca;
        this.UlicaPosiljaoca = input.UlicaPosiljaoca;
        this.GradPosiljaoca = input.GradPosiljaoca;
        this.PostojiUBazi = input.Postoji == true ? 'DA' : 'NE';
        this.Postoji = input.Postoji;
        this.BrojDokumenta = input.BrojDokumenta;
        this.DatumDokumenta =  input.DatumDokumenta;
        return this;
    }

}